module.exports = __webpack_public_path__ + "img/brick-rect.3fc02157.svg";